import { gql } from '@apollo/client';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { formatVertical } from '@moda/portal-stanchions';
import { TrunkshowTitleFragment } from '../generated/types';

export const TRUNKSHOW_TITLE_FRAGMENT = gql`
  fragment TrunkshowTitleFragment on Trunkshow {
    name
    designerNames: designer_names
    seasonName: season_name
  }
`;

export const useTrunkshowTitle = (trunkshow?: TrunkshowTitleFragment | null) => {
  const { vertical = 'women' } = useParams<{ vertical?: string }>();

  return useMemo(() => {
    if (!trunkshow) return '';

    const verticalText = formatVertical(vertical);
    const designerNames = trunkshow.designerNames ?? [];
    const designerName = designerNames[0];
    const seasonName = trunkshow.seasonName;

    return designerNames.length > 1 && trunkshow.name
      ? trunkshow.name.replace('Moda Operandi', '')
      : `${verticalText} ${designerName} ${seasonName} collection`;
  }, [trunkshow, vertical]);
};
